
    import __i18nConfig from '@next-translate-root/i18n'
    import __appWithI18n from 'next-translate/appWithI18n'
    
import React from 'react';
import { useDispatch } from 'react-redux';
import { useRouterEvents } from '@dotone/react-ui-core/hooks';
import { useCurrentUser, useShallowEqualSelector } from '@hooks';
import { deauthenticate, reauthenticate } from '@actions';
import { isProduction, envVars } from '@constants';
import * as appEnvVars from '@constants/envVars';
import { checkEmptyVars } from '@dotone/react-ui-core/utils';
import { ToastProvider, useToasts } from 'react-toast-notifications';
import { DotOneProvider, SessionTimeout } from '@dotone/react-ui-core';
import { NotificationChannel, NotificationToast } from '@components';
import wrapper from '../store';

import '@styles/globals.scss';

checkEmptyVars(appEnvVars);

const CustomToast = (props) => <NotificationToast {...props} />;

function MyApp(props) {
  const dispatch = useDispatch();
  const { timeZone, currency, currentUser } = useCurrentUser();
  const { Component, pageProps, router } = props;
  const { locale, query } = router;

  const loading = useRouterEvents(router);

  const { _sentryBaggage, _sentryTraceData, ...restPageProps } = pageProps;
  const sanitizedPageProps = isProduction ? pageProps : restPageProps;

  const { isAuthenticated } = useShallowEqualSelector(({ auth }) => auth);

  const logout = () => {
    dispatch(deauthenticate());
  };

  const handleRefreshToken = () => {
    dispatch(reauthenticate());
  };

  return (
    <DotOneProvider
      locale={locale}
      test={query.test}
      timeZone={timeZone}
      currency={currency}
      role="network"
      env={process.env.NODE_ENV}
      appApiUrl={envVars.appApiUrl}
      actionCableUrl={envVars.actionCableUrl}
      useToasts={useToasts}
      userId={currentUser.id}
    >
      <ToastProvider
        placement="top-center"
        autoDismiss={true}
        components={{ ToastContainer: CustomToast }}
        transitionDuration={250}
      >
        {!!currentUser.id && <NotificationChannel />}
        <SessionTimeout
          onLogout={logout}
          onRefresh={handleRefreshToken}
          isAuthenticated={isAuthenticated}
        />
        <Component {...sanitizedPageProps} loading={loading} />
      </ToastProvider>
    </DotOneProvider>
  );
}

const __Page_Next_Translate__ = wrapper.withRedux(MyApp);


    export default __appWithI18n(__Page_Next_Translate__, {
      ...__i18nConfig,
      isLoader: true,
      skipInitialProps: false,
      loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
    });
  